<div class="permissions-crud-wrapper" *ngIf="permissionsData">
  <mat-table [dataSource]="permissionsData" [ngClass]="isTeamAdmin ? 'team-admin' : ''">

    <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns; let i = index">
      <mat-header-cell *matHeaderCellDef>{{ column | translate }}</mat-header-cell>

      <ng-container [ngSwitch]="columnsList[i]">
        <ng-container *ngSwitchCase="crudOperations.Read">
          <mat-cell *matCellDef="let tablePermission" class="permission">
            <i
              class="material-icons"
              [ngClass]="{ 'green-color': tablePermission[crudOperations.Read]['isAllowed'],
               'red-color': !tablePermission[crudOperations.Read]['isAllowed'] }"
              (click)="changePermission(crudOperations.Read)"
            >
              {{ tablePermission[crudOperations.Read]['isAllowed'] ? 'done' : 'close' }}
            </i>
          </mat-cell>
        </ng-container>

        <ng-container *ngSwitchCase="crudOperations.Update">
          <mat-cell *matCellDef="let tablePermission" class="permission">
            <i
              class="material-icons"
              [ngClass]="{ 'green-color': tablePermission[crudOperations.Update]['isAllowed'],
               'red-color': !tablePermission[crudOperations.Update]['isAllowed'] }"
              (click)="changePermission(crudOperations.Update)"
            >
              {{ tablePermission[crudOperations.Update]['isAllowed'] ? 'done' : 'close' }}
            </i>
          </mat-cell>
        </ng-container>

        <ng-container *ngSwitchCase="crudOperations.Create">
          <mat-cell *matCellDef="let tablePermission" class="permission">
            <i
              class="material-icons"
              [ngClass]="{ 'green-color': tablePermission[crudOperations.Create]['isAllowed'],
               'red-color': !tablePermission[crudOperations.Create]['isAllowed'] }"
              (click)="changePermission(crudOperations.Create)"
            >
              {{ tablePermission[crudOperations.Create]['isAllowed'] ? 'done' : 'close' }}
            </i>
          </mat-cell>
        </ng-container>

        <ng-container *ngSwitchCase="crudOperations.Delete">
          <mat-cell *matCellDef="let tablePermission" class="permission">
            <i
              class="material-icons"
              [ngClass]="{ 'green-color': tablePermission[crudOperations.Delete]['isAllowed'],
               'red-color': !tablePermission[crudOperations.Delete]['isAllowed'] }"
              (click)="changePermission(crudOperations.Delete)"
            >
              {{ tablePermission[crudOperations.Delete]['isAllowed'] ? 'done' : 'close' }}
            </i>
          </mat-cell>
        </ng-container>
      </ng-container>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; let i = index"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns; let i = index"></mat-row>
  </mat-table>

</div>
